
import { css } from "@emotion/css";

export const BrandStyles = {
    BrokerLabelBorderOverrideCSS: "BrokerLabelBorderOverrideCSS"
};

export const getBrandedStyle = (style, brandColor) => {
    if (!brandColor) {
        return;
    }

    switch(style) {
        case "BrokerLabelBorderOverrideCSS":
            return css`
                border-bottom: 3px solid ${brandColor ? brandColor : "black"}!important;
            `;
        default:
            return;
    }
};